import Box from "@mui/material/Box"
import Rating from "@mui/material/Rating"
import Typography from "@mui/material/Typography"
import dynamic from "next/dynamic"
import { isDefined, round } from "../../config/helpers"
import P, { Span } from "../Reusables/Typography/P"
const ProductPriceContainer = dynamic(() => import('../Reusables/ProductPriceContainer2'));

const ProductHeading = (props) => {
    const {
        product, 
        product_rating, 
        product_rating_count, 
        template_page_settings,
        setActiveTabValue = false
    } = props;

    const handleAnchorClick = (value) => {
        setActiveTabValue(value)
    }

    return (
        <div className={product.package_core_group_id != null ? 'd-none': ''}>
            {product?.package_core_group_id != null && (
                <div dangerouslySetInnerHTML={{
                    __html: product.product_description_short
                }}/>
            )}
            <Typography 
                sx={{
                    fontSize: '1.5rem'
                }} 
                component="h1" 
                variant="p" 
                color="primary" 
                className={`fw-bold w-100 pb-2`}
                itemProp="name"
            >
                {product.product_name}
            </Typography>

            

            <div className="d-flex justify-space-between text-vertical rating-container">
                <Typography itemProp="sku" color="grey" component="span" variant="span" className={`f-size_2`}>{product.product_code}</Typography>
                <Span itemProp="description" className="d-none">{product.product_meta_desc}</Span>

                {isDefined(product.stock_holding) && product.stock_holding > 0 ? 
                (
                    <>
                        <br/><Typography Type="span">{product.stock_holding} Available</Typography>
                    </>
                )
                : null}

                {product_rating_count >= 0 && product_rating ? (
                    <Box itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating" className="product-reviewss d-flex mb-0 mt-1 p-1">
                        {product_rating ? (
                            <Box className="d-contents text-vertical">
                                <Span className="d-none" itemProp="ratingValue">{product?.product_rating && product.product_rating >= 3.5 ? round(product.product_rating, 1) : round(5)}</Span>
                                {product_rating > 3.5 && <Rating name="read-only" precision={0.5} value={round(product_rating)} readOnly />}
                                <a href="#reviews" onClick={() => handleAnchorClick('reviews')}>
                                    <Typography className={`link pointer ${product?.product_rating < 3.5 ? 'd-none' : ''}`} itemProp="reviewCount" sx={{marginTop:0.2}}>({product_rating_count && product?.product_rating > 3.5 ? product_rating_count : "1"/*'Not yet rated' */})</Typography>
                                </a>
                                <Span itemProp="bestRating" content="5"/>
                                <Span itemProp="worstRating" content="1"/>
                            </Box>
                        ) : null}
                    </Box>
                ) : (
                    <Box itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating" className="product-reviewss d-none mb-0 mt-1 p-1">
                        <Box className="d-contents text-vertical">
                            <Span className="d-none" itemProp="ratingValue">{round(5)}</Span>
                            <Typography className='d-none' itemProp="reviewCount" sx={{marginTop:0.2}}>1</Typography>
                            <Span itemProp="bestRating" content="5"/>
                            <Span itemProp="worstRating" content="1"/>
                        </Box>
                </Box>
                )}  
            </div>

            <div>
                <ProductPriceContainer
                    on_offer={product.on_offer}
                    poa_price={product.poa_price}
                    price_breaks={product.price_breaks}
                    product_price={product.product_price}
                    new_price={product.discounted_price}
                    template_page_settings={template_page_settings}
                    all_in_price={product.all_in_price}
                />
            </div>

            <span>
                
                <meta content="GBP" />
                <meta content={product.product_price}/>
                {/* <Box className="mt-5 f-size_3">
                    {product.on_offer == 'yes' ? (
                        product.poa_price == 'no' ? (
                            isDefined(product.price_breaks) && count(product.price_breaks) != 0 ? (
                                <Typography color="primary" component="span" variant="span">
                                    <Typography color="primary" component="span" variant="span">From</Typography>
                                    &nbsp; <Typography component="span" variant="span" className="fw-bold">{vatPricing(VATFlag, tax, product.product_price)}</Typography>
                                </Typography>
                            ) : <Typography color="primary" component="span" variant="span">{product.product_price} / 1-7 days <Typography color="primary" component="span" variant="span" style={{color: 'red'}}>{product.product_price-((product.special_discount*product.product_price)/100)} / 1-7 days</Typography></Typography>
                        ) : product.price + 'POA'
                    ) : 
                    (product.poa_price == 'no' ? (
                        isDefined(product.price_breaks) && count(product.price_breaks) != 0 ? (
                            <Typography color="primary" component="span" variant="span"><Typography color="primary" component="span" variant="span">From</Typography>&nbsp; 
                            <Typography component="span" variant="span" className="fw-bold">{vatPricing(VATFlag, tax, product.product_price)}</Typography> / 1-7 days</Typography>
                        ) : (
                        <>
                            <Typography color="primary" component="span" variant="span" className="fw-bold">{vatPricing(VATFlag, tax, product.product_price)}</Typography>
                            <Typography color="primary" component="span" variant="span"> / 1-7 days</Typography>
                        </>)
                    ) : 'POA')
                    }
                    
                    {product.product_rating_count > 0 ? (
                        <div className="product-reviews">
                            {product.product_rating ? (
                                <Box className="">
                                </Box>
                            ) : null}
                        </div>
                    ) : null}

                </Box> */}
            </span>
        </div>
    )
}

export default ProductHeading